
/* INT: Bug B fix — apparel thumb-click reliability v1
   ────────────────────────────────────────────────────
   Pipeline's vendored Media.doImageChange (theme.js line 6925-6936) uses
   live flkty.cells.findIndex against data-media-id, which is the correct
   lookup. But the diagnostic showed dead clicks after VIA rebuilds the
   cell list (Phase 5 in the Claude Chrome report). Two likely causes:

   (1) Thumbs injected by VIA after Media class init aren't wired into
       Pipeline's click→theme:image:change dispatch chain, so clicking
       them never triggers doImageChange.
   (2) The target media-id is filtered out of flkty.cells by VIA's
       variant filter — findIndex returns -1, flkty.select(-1) no-ops.

   This handler runs in CAPTURE phase before Pipeline's. It does the
   lookup against the live Flickity, calls select directly, and stamps
   is-activated. It does NOT call stopImmediatePropagation — Pipeline's
   handler can still fire in bubble phase. Its flkty.select call becomes
   a no-op since we've already navigated; its scrollThumbs() side effect
   still runs (preserves Pipeline's thumb-strip auto-scroll on the
   subset of thumbs Pipeline did bind). */
(function _intApparelThumbReliability() {
  document.addEventListener('click', function (e) {
    var thumb = e.target && e.target.closest && e.target.closest('[data-slideshow-thumbnail]');
    if (!thumb) return;

    var ss = document.querySelector('[data-product-slideshow]');
    if (!ss) return;
    var mediaId = thumb.dataset.mediaSelect;
    if (!mediaId) return;

    var _Flk = window.Flickity || (window.themeVendor && window.themeVendor.Flickity);
    var flkty = _Flk && _Flk.data && _Flk.data(ss);
    if (!flkty ||  !flkty.cells) return;

    /* Live lookup against current cell list — mirrors Pipeline's
       findIndex(matchesMedia) but tolerant to VIA's state. */
    var targetIdx = -1;
    for (var i = 0; i < flkty.cells.length; i++) {
      var el = flkty.cells[i].element;
      if (el && el.dataset && el.dataset.mediaId === mediaId) { targetIdx = i; break; }
    }

    if (targetIdx === -1) {
      /* Target media isn't in current Flickity — VIA filtered it out.
         Hide the dead thumb so the user can't click it again. */
      thumb.style.display = 'none';
      return;
    }

    flkty.select(targetIdx, false, true);

    /* Stamp is-activated correctly across all thumbs. Pipeline's
       _intApparelThumbSync also fires this on flkty.on('select') —
       double-stamp is idempotent. */
    document.querySelectorAll('[data-slideshow-thumbnail]').forEach(function (t) {
      t.classList.toggle('is-activated', t.dataset.mediaSelect === mediaId);
    });
  }, true);
})();

/* Hide thumbs whose data-media-select doesn't correspond to a slide in
   the current Flickity cell list. Runs after every VIA settle so the
   thumb strip stays aligned with the active variant's slides. */
(function intHeroHold() {
  /* INT 2026-06-05: hold the hero across VIA's destructive slide rebuild.
     VIA tears the slideshow's cells out and re-appends them by direct DOM
     surgery, not Flickity's API (confirmed: zero Flickity calls during the
     rebuild), about 0.6 to 1.3s after first paint. For the ~186ms between
     teardown and re-selection no slide is selected and the big image blanks,
     which reads as a flash. No call to wrap, so mask the gap: cache the hero
     while it is up, paint it as the flickity-viewport background whenever no
     selected hero is visible, clear it the moment the hero is back. Inline
     important is required because custom.css sets background:#fff !important
     on the viewport. Additive, self-clearing, VIA-agnostic. */
  function ssEl() { return document.querySelector('[data-product-slideshow]'); }
  function vpEl() { var s = ssEl(); return s && s.querySelector('.flickity-viewport'); }
  var heroSrc = null, holding = false, clearTimer = null, autoClear = null, log = [];
  function cacheHero() {
    var ss = ssEl(); if (!ss) return;
    var sel = ss.querySelector('[data-media-slide].is-selected');
    var img = (sel && sel.querySelector('img')) || ss.querySelector('img[fetchpriority="high"]') || ss.querySelector('img');
    if (img && img.currentSrc && img.naturalWidth > 0) heroSrc = img.currentSrc;
  }
  function heroVisible() {
    var ss = ssEl(); if (!ss) return false;
    var sel = ss.querySelector('[data-media-slide].is-selected'); if (!sel) return false;
    var img = sel.querySelector('img'); if (!img) return false;
    return getComputedStyle(sel).opacity !== '0' && getComputedStyle(img).visibility !== 'hidden' && img.naturalWidth > 0;
  }
  function hold() {
    var vp = vpEl(); if (!vp || !heroSrc) return;
    vp.style.setProperty('background-image', 'url("' + heroSrc + '")', 'important');
    vp.style.setProperty('background-size', 'contain', 'important');
    vp.style.setProperty('background-position', 'center', 'important');
    vp.style.setProperty('background-repeat', 'no-repeat', 'important');
    holding = true; log.push(['hold', Math.round(performance.now())]);
    clearTimeout(autoClear); autoClear = setTimeout(release, 3000);
  }
  function release() {
    var vp = vpEl();
    if (vp) {
      vp.style.removeProperty('background-image'); vp.style.removeProperty('background-size');
      vp.style.removeProperty('background-position'); vp.style.removeProperty('background-repeat');
    }
    if (holding) log.push(['release', Math.round(performance.now())]);
    holding = false; clearTimeout(autoClear);
  }
  function evaluate() {
    if (heroVisible()) { cacheHero(); if (holding) { clearTimeout(clearTimer); clearTimer = setTimeout(release, 60); } }
    else if (!holding) { hold(); }
  }
  cacheHero();
  [60, 150, 300, 600].forEach(function (ms) { setTimeout(cacheHero, ms); });
  var poll = setInterval(function () {
    var ss = ssEl(), slider = ss && ss.querySelector('.flickity-slider');
    if (ss && slider && !ss.__intHeroHold) {
      ss.__intHeroHold = true; clearInterval(poll);
      var mo = new MutationObserver(evaluate);
      mo.observe(slider, { childList: true });
      mo.observe(ss, { attributes: true, attributeFilter: ['class'], subtree: true });
      if (window.__intCleanupRegistry) window.__intCleanupRegistry.push(function () { mo.disconnect(); release(); ss.__intHeroHold = false; });
    }
  }, 50);
  setTimeout(function () { clearInterval(poll); }, 8000);
  window.__intHeroHoldDump = function () { return { heroSrc: !!heroSrc, log: log }; };
})();

(function _intHideDeadThumbsModule() {
  function run() {
    var thumbs = document.querySelectorAll('[data-slideshow-thumbnail]');
    if (!thumbs.length) return;

    /* INT 2026-06-05: dedup no longer depends on finding Flickity. The
       old run() did Flickity.data(ss) and bailed at !flkty before the
       dedup loop. VIA's instance is not reliably in the standard data
       map, so on desktop run() exited every time and the duplicated rail
       stayed visible until VIA's own late refresh. A duplicate is a
       duplicate by data-media-select regardless of the cell list, so we
       dedup unconditionally. The cell list is only needed for dead-thumb
       hiding; for that we use the robust __intGetFlkty lookup with
       Flickity.data as fallback. If neither finds an instance,
       liveMediaIds stays null, we skip dead-thumb hiding, and still
       dedup. */
    var liveMediaIds = null;
    var ss = document.querySelector('[data-product-slideshow]');
    var flkty = (ss && window.__intGetFlkty) ? window.__intGetFlkty(ss) : null;
    if (!flkty && ss) {
      var _Flk = window.Flickity || (window.themeVendor && window.themeVendor.Flickity);
      flkty = (_Flk && _Flk.data) ? _Flk.data(ss) : null;
    }
    if (flkty && flkty.cells) {
      liveMediaIds = {};
      for (var i = 0; i < flkty.cells.length; i++) {
        var el = flkty.cells[i].element;
        if (el && el.dataset && el.dataset.mediaId) liveMediaIds[el.dataset.mediaId] = true;
      }
    }

    var seen = {};
    thumbs.forEach(function (thumb) {
      var sel = thumb.dataset.mediaSelect;
      var dead = (liveMediaIds !== null) && (!sel || !liveMediaIds[sel]);
      var dup  = sel && seen[sel];
      if (dead || dup) {
        thumb.style.setProperty('display', 'none', 'important');
      } else {
        if (sel) seen[sel] = true;
        thumb.style.removeProperty('display');
      }
    });
  }
  /* INT 2026-07: exposed so the swatch-click thumb-rail lock can force a
     synchronous dead-thumb pass right before it unmasks the rail */
  window.__intHideDeadThumbs = run;
  document.addEventListener('int:gallery:settled', run);
  setTimeout(run, 1200);
  setTimeout(run, 3000);

  /* INT 2026-06-05: poll run across the whole settle window. The two
     fixed timers and the wrapper observer were missing the moment the
     duplicates reach their final state on slower connections, so the
     dedup never fired against it. run() is idempotent and cheap, so poll
     every 250ms until the rail holds steady for a second or 12s passes. */
  (function () {
    var stable = 0, elapsed = 0, lastSig = '';
    var iv = setInterval(function () {
      elapsed += 250;
      run();
      var t = document.querySelectorAll('[data-slideshow-thumbnail]'), vis = 0;
      for (var i = 0; i < t.length; i++) { if (getComputedStyle(t[i]).display !== 'none') vis++; }
      var sig = t.length + ':' + vis;
      if (sig === lastSig) stable++; else { stable = 0; lastSig = sig; }
      if (stable >= 4 || elapsed >= 12000) clearInterval(iv);
    }, 250);
    if (window.__intCleanupRegistry) {
      window.__intCleanupRegistry.push(function () { clearInterval(iv); });
    }
  })();

  /* INT 2026-06-04b: re-run on thumb-rail mutations. On mobile, VIA's
     duplicate-thumb injection can land after the 1200/3000 timers, and
     int:gallery:settled does not reliably fire on that path, so the dedup
     above misses the late copy (diagnostic: mobile 390px showed the six
     royal-blue selects doubled, 12 visible of 59). A debounced observer
     on the thumb wrapper catches the late rebuild. run() is idempotent
     and only toggles display, so it never retriggers this childList
     observer. Mirrors the sentinel re-hide observer above. */
  (function () {
    var _root = document.querySelector('.media__thumb__wrapper, .media__thumb__holder');
    if (!_root || _root.__intDedupObs) return;
    _root.__intDedupObs = true;
    var _t = null;
    var _mo = new MutationObserver(function () {
      clearTimeout(_t);
      _t = setTimeout(run, 200);
    });
   _mo.observe(_root, { childList: true, subtree: true });
    if (window.__intCleanupRegistry) {
      window.__intCleanupRegistry.push(function () { _mo.disconnect(); _root.__intDedupObs = false; });
    }
  })();
})();
